export const CUISINE_OPTIONS = [
  'american',
  'italian',
  'mexican',
  'asian',
  'mediterranean',
  'indian',
  'french',
  'greek',
  'japanese',
  'chinese',
  'thai',
  'middle_eastern',
  'southern',
  'tex_mex',
  'caribbean',
] as const;

export type CuisineOption = (typeof CUISINE_OPTIONS)[number];

export const DIETARY_RESTRICTION_OPTIONS = [
  'vegetarian',
  'vegan',
  'gluten_free',
  'dairy_free',
  'nut_free',
  'halal',
  'kosher',
  'low_sodium',
  'low_carb',
  'keto',
  'paleo',
] as const;

export type DietaryRestrictionOption = (typeof DIETARY_RESTRICTION_OPTIONS)[number];

export const UNIT_OPTIONS = [
  'piece',
  'oz',
  'lb',
  'g',
  'kg',
  'cup',
  'tbsp',
  'tsp',
  'ml',
  'l',
  'bunch',
  'can',
  'bag',
  'box',
  'jar',
  'loaf',
  'dozen',
  'pint',
  'quart',
  'gallon',
] as const;

export type UnitOption = (typeof UNIT_OPTIONS)[number];

export const MAX_DENY_LIST_ITEMS = 200;
export const MAX_MEAL_PLANS_PER_DAY = 5;

// Rate limiting constants
export const RATE_LIMIT_LOGIN_ATTEMPTS = 5;
export const RATE_LIMIT_LOGIN_WINDOW_SECONDS = 900; // 15 minutes
export const RATE_LIMIT_SIGNUP_ATTEMPTS = 3;
export const RATE_LIMIT_SIGNUP_WINDOW_SECONDS = 3600; // 1 hour
export const ACCOUNT_LOCKOUT_ATTEMPTS = 10;
export const ACCOUNT_LOCKOUT_WINDOW_SECONDS = 1800; // 30 minutes
export const ACCOUNT_LOCKOUT_DURATION_SECONDS = 900; // 15 minutes

// Token lifetimes
export const ACCESS_TOKEN_EXPIRY_SECONDS = 900; // 15 minutes
export const REFRESH_TOKEN_EXPIRY_DAYS = 7;

// Price integrity
export const PRICE_INTEGRITY_MAX_DEVIATION = 3.0; // 300%
